import React, { useState } from 'react';
import {
  ArrowLongLeftIcon,
  ArrowLongRightIcon,
} from '@heroicons/react/20/solid';
import { hintergruende } from '@utils/hintergruende';
import { patternStyle, resolvePatternKey } from '@utils/heroPatterns';

function paginate(array, page_size, page_number) {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
}

const MusterEinstellungen = ({
  defaultType,
  name,
  previewColor,
  previewOpacity,
}) => {
  const [pageNumber, setPageNumber] = useState(1);
  const sortedHintergruende = paginate(hintergruende, 6, pageNumber);
  const useLivePreview =
    previewColor !== undefined && previewOpacity !== undefined;
  return (
    <>
      <div className="sm:col-span-6">
        <fieldset>
          <legend className="block text-sm font-medium leading-6 text-gray-900">
            Muster auswählen
          </legend>
          <div className="mt-2">
            <ul
              role="list"
              className="grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-3 xl:gap-x-8 xl:grid-cols-6"
            >
              {sortedHintergruende.map((file) => {
                const tileStyle = useLivePreview
                  ? patternStyle({
                      key: resolvePatternKey(file.title),
                      color: previewColor,
                      opacity: previewOpacity,
                      scale: 1,
                    })
                  : { backgroundImage: file.backgroundImage };
                return (
                  <li key={file.title} className="relative">
                    <label>
                      <input
                        id={file.title}
                        type="radio"
                        name={name}
                        value={file.title}
                        defaultChecked={file.title === defaultType}
                        className="peer absolute inset-0 focus:outline-hidden opacity-0 cursor-pointer"
                      ></input>
                      <div className="group aspect-h-7 aspect-w-11 block w-full overflow-hidden rounded-lg bg-gray-100 peer-checked:ring-2  peer-checked:ring-offset-2 peer-checked:ring-offset-gray-100 cursor-pointer peer-checked:ring-svisit-primary-500">
                        <div
                          style={tileStyle}
                          className="object-cover group-hover:opacity-75"
                        />
                      </div>
                    </label>
                    <p className="pointer-events-none mt-2 block truncate text-sm font-medium text-gray-600">
                      {file.title}
                    </p>
                  </li>
                );
              })}
            </ul>
          </div>
          <nav className="flex items-center justify-between px-4 sm:px-0 mt-4">
            <div className="-mt-px flex w-0 flex-1 cursor-pointer">
              {pageNumber === 1 ? (
                ''
              ) : (
                <a
                  onClick={() => setPageNumber(pageNumber - 1)}
                  className="inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-900 hover:border-gray-300 hover:text-gray-700"
                >
                  <ArrowLongLeftIcon
                    className="mr-3 h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                  Vorherige
                </a>
              )}
            </div>
            <div className="-mt-px flex w-0 flex-1 justify-end cursor-pointer">
              {Object.keys(sortedHintergruende).length < 6 ? (
                ''
              ) : (
                <a
                  onClick={() => setPageNumber(pageNumber + 1)}
                  className="inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-900 hover:border-gray-300 hover:text-gray-700"
                >
                  Nächste
                  <ArrowLongRightIcon
                    className="ml-3 h-5 w-5 text-gray-400"
                    aria-hidden="true"
                  />
                </a>
              )}
            </div>
          </nav>
        </fieldset>
      </div>
    </>
  );
};

export default MusterEinstellungen;
